export default {
    approvalFlow: {
        cooperative: {
            delete: 'Futa Shirika',
            deactivate: 'Zima Shirika',
            activate: 'Amilisha Shirika',
            add: 'Ongeza Shirika Jipya',
            edit: 'Hariri Shirika',
            cooperativeName: 'Jina la Shirika',
            cooperativeNameTT: 'Jina la kisheria lililosajiliwa la shirika, linalotumika katika rekodi zote za utii na ripoti.',
            membershipPlan: 'Mpango wa Uanachama',
            membershipPlanTT: 'Mpango au makubaliano unaoelezea masharti na hali za uanachama katika shirika.',
            primaryContact: 'Mawasiliano Mkuu',
            primaryContactTT: 'Jina la mawasiliano, barua pepe, simu.',
            firstName: 'Jina la Kwanza',
            lastName: 'Jina la Mwisho',
            phoneNumber: 'Nambari ya Simu',
            email: 'Barua pepe',
            location: 'Mahali',
            locationTT: 'Chuja kwa maandishi ya eneo (nchi/mkoa/mji).',
            country: 'Nchi',
            countryTT: 'Nchi ambapo shirika limesajiliwa kisheria na linatumika. Hii husaidia kuunganisha ripoti na sheria za kitaifa.',
            provinceState: 'Mkoa/Jimbo',
            provinceStateTT: 'Mkoa au jimbo ambapo shirika limesajiliwa kisheria na linatumika. Hii husaidia kuunganisha ripoti na sheria za kikanda.',
            regionDistrict: 'Mkoa/Wilaya',
            regionDistrictTT: 'Mkoa au wilaya ambapo shirika limejengwa. Hii husaidia kuhakikisha utambulisho sahihi katika kiwango cha jamii.',
            villageTownCity: 'Kijiji/Mji',
            villageTownCityTT: 'Jina la makazi ya kienyeji (kijiji, mji au mji) ambapo shirika limejengwa. Hii inahakikisha utambulisho sahihi katika kiwango cha jamii.',
            address: 'Anwani',
            addressTT: 'Anwani kamili ya kimwili au ya posta ya shirika. Hii inapaswa kujumuisha maelezo ya barabara, ikiwa yanapatikana, kwa marejeleo sahihi katika ripoti.',
            businessInformation: 'Taarifa za Biashara',
            interestedCommodities: 'Bidhaa/Za Malengo',
            interestedCommoditiesTT: 'Inaonyesha nambari ya bidhaa na jina linalohusishwa na ripoti. Sehemu hii husaidia watumiaji kuelewa ni bidhaa gani ripoti inahusiana nayo.',
            coffee: 'Kahawa',
            cacao: 'Kakao',
            landRegistered: 'Ardhi ngapi itasajiliwa? (katika hekta)',
            userType: 'Aina ya Mtumiaji',
            userTypeTT: 'Chuja matokeo kwa jukumu/aina ya Shirika.',
            exporter: 'Mpelekezi',
            cooperative: 'Shirika',
            bothOfThem: 'Zote mbili',
            uploadLogo: 'Pakia nakala ya Logo',
            uploadLogoButton: 'PAKIA LOGO',
            enterHere: 'Ingiza hapa',
            select: 'Chagua',
            cooperativeNameRequired: 'Jina la shirika linahitajika',
            firstNameRequired: 'Jina la kwanza linahitajika',
            emailRequired: 'Barua pepe inahitajika',
            invalidEmail: 'Barua pepe si sahihi',
            required: 'Inahitajika',
            pleaseUploadValidImage: 'Tafadhali pakia faili ya picha sahihi',
            errorPreparingData: 'Hitilafu katika kuandaa data',
            cancel: 'Ghairi',
            save: 'Hifadhi',
            update: 'Sasisha',

            // List page translations
            listOfCooperatives: 'Orodha ya Mashirika',
            addCooperatives: 'Ongeza Mashirika',
            loadingData: 'Inapakia data...',
            search: 'Tafuta',
            type: 'Aina',
            cooperativeTypeInformation: 'Taarifa za Aina ya Shirika',
            all: 'Wote',
            of: 'ya',
            active: 'Aktifu',
            unregistered: 'Haija Sajiliwa',
            deactivated: 'Imezimwa',
            view: 'Angalia',
            confirmDelete: 'Thibitisha Ufutaji',
            areYouSureDeleteCooperative: 'Una uhakika unataka kufuta shirika hili?',
            updatedSuccessfully: 'Ime sasishwa kwa mafanikio',
            createdSuccessfully: 'Ime umbwa kwa mafanikio',
            errorFetchingCooperativeDetails: 'Hitilafu katika kupata maelezo ya shirika',
            errorSavingCooperative: 'Hitilafu katika kuhifadhi shirika',
            errorFetchingCooperativesData: 'Hitilafu katika kupata data ya mashirika',
            cooperativeDeactivatedSuccessfully: 'Shirika lime zimwa kwa mafanikio',
            errorDeactivatingCooperative: 'Hitilafu katika kuzima shirika',
            cooperativeDeletedSuccessfully: 'Shirika lime futwa kwa mafanikio',
            errorDeletingCooperative: 'Hitilafu katika kufuta shirika',
            // Table headers
            noOfFarms: 'No. ya Mashamba',
            cropsProducts: 'Mazao/Bidhaa',
            status: 'Hali',
            statusTT: 'Hali ya uendeshaji wa shirika katika mfumo (mfano: Aktifu, Imezimwa, Haija Sajiliwa).',
            actions: 'Vitendo',
            // Cooperative types
            cooperativeAndExporter: 'Shirika + Mpelekezi',
            // Success messages
            cooperativeActivatedSuccessfully: 'Shirika lime amilishwa kwa mafanikio',
            back: 'Nyuma',
            commoditiesProducts: 'Detail Shirika',
            cooperativeEmail: 'Barua pepe Shirika',
            cooperativePhoneNumber: 'Nambari ya Simu Shirika',
            logo: 'Logo',
            logoTT: 'Picha rasmi au alama ya logo ya Shirika kwa ajili ya utambulisho katika ripoti/sukurani za QR.',
            advanced: 'Avanzado',
        },
    },
};
